import { render, staticRenderFns } from "./billing-modal-invoices-crud-card.vue?vue&type=template&id=68159257&"
import script from "./billing-modal-invoices-crud-card.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-invoices-crud-card.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports